import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/Auth/Login";
import HomePage from "../pages/Home";
import CRMRoutes from "../modules/CRM/routes";
import HRRoutes from "../modules/HR/routes";
import AccountingRoutes from "../modules/Accounting/routes";
import SettingsRoutes from "../modules/Settings/routes";
import { ProtectedRoute } from "./ProtectedRoute";
import SalesRoutes from "../modules/Sales/routes";
import PurchasesRoutes from "../modules/Purchases/routes";
import ProfilePage from "../pages/Profile";
import InventoryRoutes from "../modules/Inventory/routes";
import ProductionRoutes from "../modules/Production/routes";
import EmailLinkPage from "../pages/Auth/Password/Email";
import NewPasswordPage from "../pages/Auth/Password/New";

export default function AppRoutes() {
  return(
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/password/email" element={<EmailLinkPage />} />
      <Route path="/password/new" element={<NewPasswordPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="home" element={<HomePage />} />
        <Route path="profile" element={<ProfilePage />} />

        <Route path="crm/*" element={<CRMRoutes />} />
        <Route path="sales/*" element={<SalesRoutes />} />
        <Route path="purchases/*" element={<PurchasesRoutes />} />
        <Route path="inventory/*" element={<InventoryRoutes />} />
        <Route path="production/*" element={<ProductionRoutes />} />
        <Route path="hr/*" element={<HRRoutes />} />
        <Route path="accounting/*" element={<AccountingRoutes />} />
        <Route path="settings/*" element={<SettingsRoutes />} />
      </Route>
    </Routes>
  );
}